

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.BDEgZCgY.js","_app/immutable/chunks/disclose-version.C-B3b31r.js","_app/immutable/chunks/runtime.CwyCtKqw.js","_app/immutable/chunks/legacy.CiTDcgnC.js","_app/immutable/chunks/render.Cf7suz1b.js","_app/immutable/chunks/lifecycle.D4WOZN2H.js","_app/immutable/chunks/entry.5WM1SLwB.js","_app/immutable/chunks/index-client.DF3tuuDA.js"];
export const stylesheets = [];
export const fonts = [];
